"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EditModal", {
  enumerable: true,
  get: function get() {
    return _EditModal.EditModal;
  }
});
var _EditModal = require("./EditModal");